import { render, staticRenderFns } from "./vertical-steps-flowV2.vue?vue&type=template&id=115bb354&"
import script from "./vertical-steps-flowV2.vue?vue&type=script&lang=js&"
export * from "./vertical-steps-flowV2.vue?vue&type=script&lang=js&"
import style0 from "./vertical-steps-flowV2.vue?vue&type=style&index=0&id=115bb354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports